module.exports = __webpack_public_path__ + "didnt-redeem.svg?c8c2ac11079857498ab25c16fc310a93";